require("!!/home/runner/work/dlgsc-v2/dlgsc-v2/node_modules/script-loader/addScript.js")(require("!!/home/runner/work/dlgsc-v2/dlgsc-v2/node_modules/raw-loader/index.js!/home/runner/work/dlgsc-v2/dlgsc-v2/node_modules/core-js/modules/es6.regexp.exec.js"))


//////////////////
// WEBPACK FOOTER
// ../~/core-js/modules/es6.regexp.exec.js
// module id = 484
// module chunks = 0